import PropTypes from "prop-types";

const BackToSignIn = ({ path }) => (
  <div className="text-center mt15">
    <a href={path} className="auth-secondary-link">
      Back to sign in
    </a>
  </div>
);

BackToSignIn.propTypes = {
  path: PropTypes.string.isRequired,
};

export default BackToSignIn;
